<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="pageSetting.pageTitle" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="flex-100 w-limit">
                <div class="flex-1">
                    <div class="p-x-20 p-y-16">
                        <div class="p-d-16">
                            <SOInputSelect
                                :title="'Pilih Outlet'"
                                :required="true"
                                :selected="payload.idoutlet"
                                :placeholder="'Pilih outlet...'"
                                :options="optionsOutlet"
                                @option-selected="(v) => (payload.idoutlet = v)"
                            />
                            <ErrorMessage class="error" label="Outlet" :validation="$v.payload.idoutlet" />
                        </div>

                        <div class="p-d-16">
                            <SOInputNominal
                                :title="'Nominal'"
                                :placeholder="'123.456'"
                                :required="true"
                                :prefix-left="true"
                                :prefix="'Rp'"
                                :use-autocomplete="false"
                                :use-comma="true"
                                @input="
                                    (v) => {
                                        payload.nominal = v;
                                    }
                                "
                            />
                            <ErrorMessage class="error" label="Nominal" :validation="$v.payload.nominal.formatted" />
                        </div>

                        <div class="p-d-16">
                            <SOInputSelect
                                :title="'Biaya dari akun'"
                                :required="true"
                                :selected="payload.idakun"
                                :placeholder="'Pilih akun...'"
                                :options="optionsAkun"
                                @option-selected="(v) => (payload.idakun = v)"
                            />
                            <ErrorMessage class="error" label="Biaya dari akun" :validation="$v.payload.idakun" />
                        </div>

                        <div class="p-d-16">
                            <SOInputSelect
                                class="p-d-8"
                                :title="'Untuk biaya'"
                                :required="true"
                                :selected="payload.idbiaya"
                                :placeholder="'Pilih akun biaya...'"
                                :options="optionsBiaya"
                                @option-selected="selectedBiaya"
                            />
                            <ErrorMessage class="error" label="Untuk biaya" :validation="$v.payload.idbiaya" />
                            <SOInputSelect
                                :title="''"
                                :required="false"
                                :selected="payload.idbiayaItem"
                                :placeholder="'Item biaya...'"
                                :options="optionsItemBiaya"
                                @option-selected="(v) => (payload.idbiayaItem = v)"
                            />
                            <ErrorMessage class="error" label="Item biaya" :validation="$v.payload.idbiayaItem" />
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="p-x-20 p-y-16">
                        <div class="p-d-16">
                            <SOInputDateTime
                                id="waktu-pemaikaian-biaya"
                                :required="true"
                                :max-date="getDateNow"
                                :title="'Waktu pemakaian biaya'"
                                :value="$moment().format('DD/MM/YYYY HH:mm')"
                                @get-date="
                                    (v) => {
                                        payload.waktu = v;
                                    }
                                "
                            />
                            <p class="m-d-0 f-12 f-c-midgrey f-regular">
                                Waktu digunakan sebagai acuan pencatatan di jurnal.
                            </p>
                            <ErrorMessage class="error" label="Waktu pemakain biaya" :validation="$v.payload.waktu" />
                        </div>

                        <div class="p-d-16">
                            <SOInputSelect
                                :required="true"
                                :title="'Penanggung jawab'"
                                :selected="payload.penanggungJawab"
                                :placeholder="'Pilih karyawan...'"
                                :options="optionsKaryawan"
                                @option-selected="(v) => (payload.penanggungJawab = v)"
                            />
                            <ErrorMessage
                                class="error"
                                label="Penanggung jawab"
                                :validation="$v.payload.penanggungJawab"
                            />
                        </div>

                        <div>
                            <SOInputRegular
                                :title="'Catatan (Opsional)'"
                                :placeholder="'Catatan...'"
                                :value="''"
                                :validation="'alphanumeric'"
                                v-model="payload.catatan"
                            />
                        </div>
                    </div>
                </div>

                <div class="p-d-24 w-limit">
                    <div class="p-x-20">
                        <SOButton
                            :text="'Tambahkan'"
                            :primary="true"
                            :full="true"
                            :disable="pageSetting.btn.save.disabled"
                            :loading="pageSetting.btn.save.loading"
                            @action="create"
                        />
                    </div>
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minLength, required } from "vuelidate/lib/validators";

export default {
    name: "BiayaOutletCreate",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOInputSelect,
        SOInputNominal,
        SOInputDateTime,
        SOInputRegular,
        ErrorMessage,
        SOButton,
    },
    computed: {
        ...mapGetters("outletModule", {
            outlets: "getOutlet",
        }),
        ...mapGetters("metaModule", {
            karyawan: "getKaryawanAll",
            getListAssetsAccount: "getListAssetsAccount",
            keuanganBiaya: "getListKeuanganBiaya",
            biayaItem: "getListBiayaItemKategori",
        }),
        getDateNow() {
            return `${this.$moment().format("YYYY-MM-DD")}T23:59`;
        },
    },
    data() {
        return {
            pageSetting: {
                pageTitle: "Tambah Biaya di Outlet",
                loading: true,
                btn: {
                    save: {
                        disabled: false,
                        loading: false,
                    },
                },
            },
            optionsOutlet: [],
            optionsAkun: [],
            optionsBiaya: [],
            optionsItemBiaya: [],
            optionsKaryawan: [],
            payload: {
                idoutlet: "",
                nominal: {
                    formatted: "",
                    raw: 0,
                },
                idakun: "",
                idbiaya: "",
                idbiayaItem: "",
                waktu: "",
                penanggungJawab: "",
                catatan: "",
            },
        };
    },
    validations: {
        payload: {
            idoutlet: {
                required,
            },
            nominal: {
                formatted: {
                    required,
                    minLength: minLength(1),
                },
            },
            idakun: {
                required,
            },
            idbiaya: {
                required,
            },
            idbiayaItem: {
                required,
            },
            waktu: {
                required,
            },
            penanggungJawab: {
                required,
            },
        },
    },
    mounted() {
        this.init();
        this.smartTrackingView("add_biaya_outlet");
    },
    methods: {
        ...mapActions({
            createBiayaOutlet: "biayaOutletModule/createBiayaOutlet",
            resetBiayaOutlet: "biayaOutletModule/resetBiayaOutlet",
        }),
        back() {
            this.$router.back();
        },
        async init() {
            await this.getOutlet();
            await this.getAssetsAccount();
            await this.getKeuanganBiaya();
            await this.getKaryawan();
            this.pageSetting.loading = false;
        },

        async getOutlet() {
            const res = await this.$store.dispatch("outletModule/fetchOutletAll");
            if (res.success) {
                for (let i = 0; i < this.outlets.data.length; i++) {
                    this.optionsOutlet = [
                        ...this.optionsOutlet,
                        {
                            id: this.outlets.data[i].idoutlet,
                            text: this.outlets.data[i].nama,
                        },
                    ];
                }
            } else {
                this.$toast.error(res.err);
            }
        },
        async getAssetsAccount() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchAssetsAccount");
            if (res.success) {
                this.pageSetting.loading = false;
                this.optionsAkun = [];
                this.getListAssetsAccount.forEach((v) => {
                    this.optionsAkun = [
                        ...this.optionsAkun,
                        {
                            id: v.idakun,
                            text: v.nama_akun,
                        },
                    ];
                });
            } else {
                this.pageSetting.loading = false;
                this.$toast.error(res.err);
            }
        },
        async getKaryawan() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchKaryawanAll");
            this.pageSetting.loading = false;
            if (res.success) {
                this.optionsKaryawan = [];
                this.karyawan.forEach((v) => {
                    this.optionsKaryawan = [
                        ...this.optionsKaryawan,
                        {
                            id: v.idkaryawan,
                            text: v.nama,
                        },
                    ];
                });
            } else {
                this.$toast.error(res.err);
            }
        },
        async getKeuanganBiaya() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchListKeuanganBiaya");
            this.pageSetting.loading = false;
            if (res.success) {
                this.optionsBiaya = [];
                let i = 0;
                this.keuanganBiaya.forEach((kategori) => {
                    this.optionsBiaya = [
                        ...this.optionsBiaya,
                        {
                            id: kategori.idkategori,
                            text: kategori.nama_kategori,
                            children: [],
                        },
                    ];

                    kategori.keuangan_akun_akun.forEach((v) => {
                        this.optionsBiaya[i].children = [
                            ...this.optionsBiaya[i].children,
                            {
                                id: v.idakun,
                                text: v.nama_akun,
                            },
                        ];
                    });
                    i++;
                });
            } else {
                this.$toast.error(res.err);
            }
        },
        async getBiayaItem(id) {
            const res = await this.$store.dispatch("metaModule/fetchListBiayaItemKategori", id);
            if (res.success) {
                this.optionsItemBiaya = [];
                this.biayaItem.forEach((kategori) => {
                    kategori.biaya_item.forEach((v) => {
                        this.optionsItemBiaya = [
                            ...this.optionsItemBiaya,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    });
                });
            } else {
                this.$toast.error(res.err);
            }
        },

        selectedBiaya(val) {
            this.payload.idbiayaItem = "";
            this.payload.idbiaya = val;
            this.getBiayaItem(val);
        },
        errorValidation() {
            this.$v.payload.idoutlet.$touch();
            this.$v.payload.nominal.formatted.$touch();
            this.$v.payload.idakun.$touch();
            this.$v.payload.idbiaya.$touch();
            this.$v.payload.idbiayaItem.$touch();
            this.$v.payload.waktu.$touch();
            this.$v.payload.penanggungJawab.$touch();
            return (
                this.$v.payload.idoutlet.$invalid ||
                this.$v.payload.nominal.formatted.$invalid ||
                this.$v.payload.idakun.$invalid ||
                this.$v.payload.idbiaya.$invalid ||
                this.$v.payload.idbiayaItem.$invalid ||
                this.$v.payload.waktu.$invalid ||
                this.$v.payload.penanggungJawab.$invalid
            );
        },
        async create() {
            this.smartTrackingClick("simpan_biaya_outlet");

            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            let form = new FormData();
            form.append("idoutlet", this.payload.idoutlet);
            form.append("idakun_debet", this.payload.idbiaya);
            form.append("idakun_kredit", this.payload.idakun);
            form.append("idkaryawan", this.payload.penanggungJawab);
            form.append("idbiaya_item", this.payload.idbiayaItem);
            form.append("nominal", this.payload.nominal.raw);
            form.append("keterangan_status", this.payload.catatan);
            form.append("waktu_pakai", this.$moment(this.payload.waktu).format("YYYY-MM-DD HH:mm:ss"));

            this.pageSetting.btn.save.loading = true;
            this.pageSetting.btn.save.disabled = true;
            this.createBiayaOutlet(form)
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                        resulter.errorResult(res);
                    } else {
                        let { status, data, msg, code } = res.data;
                        if (status && code == 200) {
                            this.$toast.success(msg);
                            this.resetBiayaOutlet();
                            this.$router.back();
                            resulter.successResult(msg);
                        } else {
                            this.$toast.error(msg);
                            resulter.errorResult(msg);
                        }
                    }

                    this.pageSetting.btn.save.loading = false;
                    this.pageSetting.btn.save.disabled = false;
                })
                .catch((e) => {
                    this.pageSetting.btn.save.loading = false;
                    this.pageSetting.btn.save.disabled = false;
                    this.$toast.error(e);
                    resulter.errorResult(e);
                });
        },
    },
};
</script>
